import React from 'react';
import { Box, styled } from '@mui/material';

export const LoadingOverlayWrapper = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  zIndex: 9999,
  alignItems: 'center'
}));
